import axios from 'axios';
import moment from 'moment';
import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';
import BaseMitExternalApiService from '../../base/services/BaseMitExternalApiService.js';

class MitEquipmentApiService {
  constructor() {
    this.service = new BaseMitExternalApiService();
    this.url = BaseMitConfigService.get('CLIENT_API_EQUIPMENT');
    this.LateReturn = 0;
  }

  getAllCategory() {
    return new Promise ((resolve, reject) => {

      this.service.getData('GET', this.url,'/category')
        .then((response) => {
            let categoryModel = response.data;
            for(let x = 0; x < categoryModel.length; x++){
              categoryModel[x].last_updated_localfromnow = moment(categoryModel[x].last_updated).local().fromNow();
            }
            return resolve(categoryModel);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }

  getAllEquipment() {
    return new Promise ((resolve, reject) => {

      this.service.getData('GET', this.url,'/equipment')
        .then((response) => {
            let model = response.data;
            for(let x = 0; x < model.length; x++){
              model[x].last_updated_localfromnow = moment(model[x].last_updated).local().fromNow();
            }
            return resolve(model);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getAllReservation() {
    return new Promise ((resolve, reject) => {

      this.service.getData('GET', this.url,'/admin/reservation')
        .then((response) => {
            let model = response.data;
            for(let x = 0; x < model.length; x++){
              model[x].checkout_date_local = moment(model[x].checkout_date).local().format('MMM D YYYY, h:mm:ss a');
              model[x].due_date_local = moment(model[x].due_date).local();
              model[x].checkout_date_localfromnow = moment(model[x].checkout_date).local().fromNow();
              model[x].due_date_localfromnow = moment(model[x].due_date).local().fromNow();
            }
            return resolve(model);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getMyReservation() {
    return new Promise ((resolve, reject) => {

      this.service.getData('GET', this.url,'/reservation')
        .then((response) => {
            let model = response.data;
            for(let x = 0; x < model.length; x++){
              model[x].checkout_date_local_Readable = moment(model[x].checkout_date).local().format('MMM D, YY, h:mm a');
              model[x].due_date_local_Readable =  moment(model[x].due_date).local().format('MMM D, YY, h:mm a');
              model[x].checkout_date_localfromnow = moment(model[x].checkout_date).local().fromNow(true);
              model[x].due_date_localfromnow = moment(model[x].due_date).local().fromNow(true) ;
              model[x].checkout_timestamp =  moment(model[x].checkout_date).local().valueOf();
              model[x].due_timestamp =  moment(model[x].due_date).local().valueOf();
              model[x].time_now =  moment().valueOf();
              if (model[x].time_now > model[x].due_timestamp) {this.LateReturn++;};
            }
            return resolve(model);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  getAllGiveAways() {
    return new Promise ((resolve, reject) => {

      this.service.getData('GET', this.url,'/giveaway')
        .then((response) => {
            let model = response.data;
            for(let x = 0; x < model.length; x++){
              model[x].last_updated_localfromnow = moment(model[x].last_updated).local().fromNow();
            }
            return resolve(model);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
}

export default MitEquipmentApiService;
